<template>
  <div class="main-content">
    <PageHeader :page="page" @action="createNew"/>
    <div class="content">
      <DataTable :tableData="tableData" @edit="edit" @view="view" @schedule="schedule" @terminate="terminate" @task="showTask"/>
    </div>
  </div>

  <ModalView
    :isVisible="state.addStaffModal"
    :fixclose="true"
    @close="state.addStaffModal = false">
    
    <DynamicForm :columns="2"
      :fields="newFields" @submit="addUser"
      :submitting="state.submitting" :errors="state.errors"
      :success="state.success" />
  </ModalView> 

  <ModalView
    :isVisible="state.terminateStaffModal"
    :fixclose="true"
    @close="state.terminateStaffModal = false">

      <DynamicForm  :columns="1"
        :fields="terminateFields" @submit="terminateStaff"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
  </ModalView> 

  <ModalView
    :isVisible="state.editStaffModal"
    :fixclose="true"
    @close="state.editStaffModal = false">

    <div v-if="state.gettingStaff" style="text-align: center;">
      <img src="@/assets/img/ajldr.gif" style="width:100px"/>
    </div>
    <div v-else>
      <DynamicForm  :columns="2"
        :fields="editFields" @submit="addUser"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </div>
  </ModalView> 
</template>

<script>
import icons from '@/assets/js/icons.js';
import PageHeader from '@/components/PageHeader.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import { defineComponent, ref, reactive, onMounted} from 'vue';
import ModalView from '@/components/ModalView.vue';
import DataTable from '@/components/DataTable.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import { usePermissions } from '@/composables/usePermissions';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'StaffMgt',
  components:{PageHeader,DynamicForm,ModalView,DataTable},
  setup(){
    const { hasPermission } = usePermissions();
    const state=reactive({addStaffModal:false, submitting:false, error:[],success:false,
      editDeptModal:false, etype:[],editStaffModal:false,terminateStaffModal:false
    })
    const router = useRouter();
    const svgIcons = ref(icons);
    const etype=ref([])
    const depts=ref([])
    const supe=ref([])
    const jobs=ref([])
    const template=ref([])
    const terminateFields=ref([])
    const page=reactive({title:"Staff Management", btn:"Create new",
    desc:"The Staff Management page provides tools to oversee and organize your team effectively."+
    " Use this page to manage staff roles, assign tasks, and update contact information. "+
    "Click on any staff member to view details, adjust permissions, or track performance metrics"})
    if(!hasPermission('Team', 'create')){
      page.btn="";
    }
    
    const newFields=ref([
      { name: "Personal Info", number: "1",data: 
        [{ type: 'text', name: 'name', label: 'Staff Name',
          value: ""  },
          { type: 'select', name: 'gender', label: 'Gender',
            value: "",options:[{label:"Male", value:"male"}, {label:"Female", value:"female"},]
          },
          { type: 'text', name: 'phone', label: 'Phone No', 
          value: ""  }
        ]
      },
      { name: "Login Info", number: "2",data: 
        [{ type: 'text', name: 'email', label: 'Work Email', 
          value: ""  },
          { type: 'password', name: 'password', label: 'Password', 
          value: ""  }
        ]
      },
      { name: "Office Info", number: "3",data: 
        [{ type: 'select', name: 'title', label: 'Job Title',
          value: "",options:jobs  },
          { type: 'select', name: 'dept', label: 'Department', 
          value: "", options:depts },
          { type: 'text', name: 'e_id', label: 'Employee ID', 
          value: ""  },
          { type: 'select', name: 'etype', label: 'Employment Type', 
          value: "", options:etype},
          { type: 'select', name: 'supervisor', label: 'Supervisor',
          value: "",options:supe  },
          { type: 'date', name: 'date', label: 'Employment Date', 
          value: ""  },
          { type: 'select', name: 'salary', label: 'Salary', options:template, 
          value: "",desc:"You can customize template for this staff on Salary Mgt. page"  }
        ]
      }
    ])
    
    const editFields=ref([])
    
    function setErrors(res){
      var errors=[];
      Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
          er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
      });
      state.errors=errors;
    }

    function addUser(data){
      state.submitting=true;
      state.errors=[];
      data.addUser="";
      call({
        url:urls.staff,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            setTable(res.msg);
          }else{
            setErrors(res)
          }
        }
      })
    }

    const tableData = ref({
      rows: [],
      loading: true,
      columns: [
        { label: "SN" },
        { label: "Name" },
        { label: "Department" },
        { label: "Job Title" }
      ],
      options:{
        label:"Actions",
        action_label:[icons.view],
        action:["view"]
      },
      total:0
    });

    if(hasPermission('Schedule', 'view')){
      tableData.value.options.action.push("schedule");
      tableData.value.options.action_label.push(icons.schedule);
    }

    if(hasPermission('Task Assignment', 'view')){
      tableData.value.options.action.push("task");
      tableData.value.options.action_label.push(icons.task);
    }

    if(hasPermission('Team', 'edit')){
      tableData.value.options.action.push("edit");
      tableData.value.options.action_label.push(icons.edit);
    }

    if(hasPermission('Team', 'delete')){
      tableData.value.options.action.push("terminate");
      tableData.value.options.action_label.push(icons.cancel);
    }

    function setTable(msg){
      var data={}
      tableData.value.loading = false;
      tableData.value.rows.length=0
      Object.keys(msg).forEach(set => {
        data={id:msg[set].id};
        var v=[];
        Object.keys(msg[set].val).forEach(row => {
          v.push(msg[set].val[row])
        });
        data.val=v;
        tableData.value.rows.push(data)
      });
      tableData.value.total=tableData.value.rows.length
    }

    onMounted(() => {
      call({
        url:urls.staff,
        data:{startStaff:""},
        success:(res)=>{
          state.loaded=true
          if(res.status){
            var d=res.msg;
            etype.value=[];
            depts.value=[];
            supe.value=[];
            jobs.value=[];
            template.value=[];
            Object.keys(d.etype).forEach(k => {
              etype.value.push(d.etype[k])
            })
            Object.keys(d.job).forEach(k => {
              jobs.value.push(d.job[k])
            })
            Object.keys(d.dept).forEach(k => {
              depts.value.push(d.dept[k])
            })
            Object.keys(d.users).forEach(k => {
              supe.value.push(d.users[k])
            })
            Object.keys(d.template).forEach(k => {
              template.value.push(d.template[k])
            })
            setTable(d.staff)
          }else{
            alert(res.msg);
          }
        }
      })
    });

    function createNew(){
      state.success=false;
      state.error=[]
      state.addStaffModal=true;
      state.submitting=false;
    }

    function edit(i){
      state.success=false;
      state.gettingStaff=true
      state.error=[]
      var data=tableData.value.rows[i]
      var staffid=data.id
      editFields.value.length=0;
      call({
        url:urls.staff,
        data:{getStaff:staffid},
        success:(res)=>{
          state.gettingStaff=false
          if(res.status){
            var d=res.msg.staff;
            etype.value=[];
            depts.value=[];
            supe.value=[];
            jobs.value=[];
            Object.keys(res.msg.etype).forEach(k => {
              etype.value.push(res.msg.etype[k])
            })
            Object.keys(res.msg.job).forEach(k => {
              jobs.value.push(res.msg.job[k])
            })
            Object.keys(res.msg.dept).forEach(k => {
              depts.value.push(res.msg.dept[k])
            })
            Object.keys(res.msg.users).forEach(k => {
              supe.value.push(res.msg.users[k])
            })
            editFields.value.push(
              { name: "Personal Info", number: "1",data: 
                [{ type: 'text', name: 'name', label: 'Staff Name',
                  value: d.name  },
                  { type: 'select', name: 'gender', label: 'Gender',
                    value: d.gender,options:[{label:"Male", value:"male"}, {label:"Female", value:"female"},]
                  },
                  { type: 'text', name: 'phone', label: 'Phone No', 
                  value: d.phone  }
                ]
              },
              { name: "Login Info", number: "2",data: 
                [{ type: 'text', name: 'email', label: 'Work Email', 
                  value: d.email  },
                  { type: 'password', name: 'password', label: 'Password', 
                  value: "",desc:"Leave empty to remain unchanged" },
                  {type: "hidden", name:"id", value:d.id}
                ]
              },
              { name: "Office Info", number: "3",data: 
                [{ type: 'select', name: 'title', label: 'Job Title',
                  value: d.job,options:jobs  },
                  { type: 'select', name: 'dept', label: 'Department', 
                  value: d.dept, options:depts },
                  { type: 'text', name: 'e_id', label: 'Employee ID', 
                  value: d.eid  },
                  { type: 'select', name: 'etype', label: 'Employment Type', 
                  value: d.type, options:etype},
                  { type: 'select', name: 'supervisor', label: 'Supervisor',
                  value: d.spv,options:supe  },
                  { type: 'date', name: 'date', label: 'Employment Date', 
                  value: d.edate  },
                  { type: 'text', name: 'salary', label: 'Salary', readonly:true,
                  value: d.salary, desc:"Go to Salary Mgt. to manage staff salary"  }
                ]
              }
            )
          }
        }
      })
      state.editStaffModal=true;
    }

    function view(i){
      var id=tableData.value.rows[i].id
      router.push({ name: 'profile', params: { profileId: id, page:'personal_info' } });
    }

    function schedule(i){
      var id=tableData.value.rows[i].id
      router.push({ name: 'calendar', params: { id: id, type:"staff" } });
    }

    function terminate(i){
      var id=tableData.value.rows[i].id,
      name=tableData.value.rows[i].val[1];
      terminateFields.value=
      [
        { name: "Terminate "+name, number: "1",data: 
          [
            { type: 'textarea', name: 'reason', label: 'Reason',
            value: "", length: 100  },
            { type: 'date', name: 'date', label: 'Termination Date',
              value: ""
            },
            { type: 'hidden', name: 'id', value: id  }
          ]
        }
      ]
      state.terminateStaffModal=true;
      state.success=false;
      state.error=[]
      state.submitting=false;
    }

    function terminateStaff(data){
      state.submitting=true;
      state.errors=[];
      data.terminateStaff="";
      call({
        url:urls.staff,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
            setTable(res.msg);
          }else{
            setErrors(res)
          }
        }
      })
    }

    function showTask(i){
        var data=tableData.value.rows[i];
        router.push({ name: 'tasksview', params: { project: "s"+data.id } });
    }

    return{icons: svgIcons.value, page,createNew,state,newFields,view,terminateFields,showTask,
      addUser,tableData,hasPermission,edit,editFields,schedule,terminate,terminateStaff}
  }
})
</script>

<style scoped>
.card-in{background: var(--white-color); padding: 20px;}
.hd-dsc{font-size: 12px; padding: 0;}
.hd-ctr{display: flex; align-items: center;}
.hd-ctr h3{margin: 0;}
.hd-ctr .ic{width: 17px; height: 17px; fill: var(--primary-color); margin-left: 10px;
  line-height: 0; cursor:pointer;}

</style>
